import React from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import '../styles/pages/ImprovedHome.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const ImprovedHome = () => {
  // Industry data
  const industries = [
    { icon: '🏦', title: 'Banks', desc: 'Comprehensive KYC solutions for banking institutions' },
    { icon: '💼', title: 'NBFCs', desc: 'Tailored KYC assessment for non-banking financial companies' },
    { icon: '🤝', title: 'Microfinance', desc: 'Micro-KYC verification services' },
    { icon: '🏢', title: 'Fintech', desc: 'Digital lending platform integrations' },
    { icon: '🏥', title: 'Healthcare', desc: 'Medical loan verification services' },
    { icon: '🏠', title: 'Mortgage', desc: 'Home loan KYC checks' }
  ];

  // Services data
  const services = [
    { icon: '✅', title: 'KYC Verification', desc: 'Complete KYC compliance' },
    { icon: '🆔', title: 'PAN Verification', desc: 'Real-time PAN validation' },
    { icon: '⚖️', title: 'Court Case Check', desc: 'Legal record verification' },
    { icon: '📋', title: 'Age Verification', desc: 'Age checks ' },
    { icon: '📊', title: 'Instant business verification', desc: 'Create trusted business relationships.' },
    { icon: '🔍', title: 'Document verification', desc: 'Verify any government-issued document.' },
    { icon: '📈', title: ' Fraud analysts', desc: 'Fraud analysts are the unsung heroes of digital trust.' }

   
  ];

  // Slider settings
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const stats = [
    { number: '10,000+', label: 'KYC Verification Check Daily' },
    { number: '500+', label: 'Organizations' },
    { number: '99.9%', label: 'Uptime' },
    { number: '< 3 sec', label: 'Avg Response Time' }
  ];

  return (
    <div className="improved-home">
      {/* Hero Section */}
      <section className="hero-section-new">
        <div className="hero-content-wrapper">
          <div className="hero-text">
            <h1 className="hero-title-new">
              For Secure <span className="highlight">Onboarding Digital</span> KYC Verification & Fraud Prevention
            </h1>
            <p className="hero-subtitle">
              Secure, scalable, and compliant identity verification built for global businesses.
            </p>
            <div className="hero-buttons">
              <Link to="/contact" className="btn-primary-new">Get Started</Link>
              <Link to="/services" className="btn-secondary-new">Our Services</Link>
            </div>
          </div>
          <div className="hero-image">
            <div className="floating-card card-1">
              <div className="card-icon">✓</div>
              <div className="card-text">Instant Reports</div>
            </div>
            <div className="floating-card card-2">
              <div className="card-icon">🔒</div>
              <div className="card-text">100% Secure</div>
            </div>
            <div className="floating-card card-3">
              <div className="card-icon">📊</div>
              <div className="card-text">Real-time Data</div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="stats-container">
          {stats.map((stat, index) => (
            <div key={index} className="stat-item-new">
              <h3 className="stat-number">{stat.number}</h3>
              <p className="stat-label">{stat.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Industries Slider Section */}
      <section className="slider-section industries-section-new">
        <div className="section-container">
          <div className="section-header center-header">
            <h2 className="section-title">Industries We Serve</h2>
            <p className="section-subtitle">Trusted by leading financial institutions across India</p>
          </div>
          <Slider {...sliderSettings} className="custom-slider">
            {industries.map((industry, index) => (
              <div key={index} className="slider-item">
                <div className="industry-card-slider">
                  <div className="industry-icon-slider">{industry.icon}</div>
                  <h3 className="industry-title-slider">{industry.title}</h3>
                  <p className="industry-desc-slider">{industry.desc}</p>
                </div>
              </div>
            ))}
          </Slider>
          <div className="section-cta">
            <Link to="/industries" className="link-cta">View All Industries →</Link>
          </div>
        </div>
      </section>

      {/* Services Slider Section */}
      <section className="slider-section services-section-new">
        <div className="section-container">
          <div className="section-header center-header">
            <h2 className="section-title">Our Services</h2>
            <p className="section-subtitle">Comprehensive KYC verification solutions</p>
          </div>
          <Slider {...sliderSettings} className="custom-slider">
            {services.map((service, index) => (
              <div key={index} className="slider-item">
                <div className="service-card-slider">
                  <div className="service-icon-slider">{service.icon}</div>
                  <h3 className="service-title-slider">{service.title}</h3>
                  <p className="service-desc-slider">{service.desc}</p>
                </div>
              </div>
            ))}
          </Slider>
          <div className="section-cta">
            <Link to="/services" className="link-cta">View All Services →</Link>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section-new">
        <div className="features-container">
          <div className="feature-item-large">
            <div className="feature-icon-large">⚡</div>
            <h3>Lightning Fast</h3>
            <p>Get KYC Verification reports in under 3 seconds with our optimized API infrastructure</p>
          </div>
          <div className="feature-item-large">
            <div className="feature-icon-large">🔐</div>
            <h3>Bank-Grade Security</h3>
            <p>AES-256 encryption and ISO 27001 certified infrastructure for data protection</p>
          </div>
          <div className="feature-item-large">
            <div className="feature-icon-large">📱</div>
            <h3>Easy Integration</h3>
            <p>RESTful APIs with comprehensive documentation for seamless integration</p>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works-new">
        <div className="section-container">
          <div className="section-header center-header">
            <h2 className="section-title">How It Works</h2>
            <p className="section-subtitle">Get started in 4 simple steps</p>
          </div>
          
          <div className="steps-grid">
            <div className="step-card-new">
              <div className="step-number-new">1</div>
              <h3>Register</h3>
              <p>Sign up and get instant access to your dashboard</p>
            </div>
            <div className="step-card-new">
              <div className="step-number-new">2</div>
              <h3>Top-up Wallet</h3>
              <p>Add credits to your wallet securely</p>
            </div>
            <div className="step-card-new">
              <div className="step-number-new">3</div>
              <h3>Run Checks</h3>
              <p>Execute credit checks with a single click</p>
            </div>
            <div className="step-card-new">
              <div className="step-number-new">4</div>
              <h3>Download Reports</h3>
              <p>Get instant PDF reports ready to use</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section-new">
        <div className="cta-content">
          <h2>Ready to Get Started?</h2>
          <p>Join hundreds of organizations using LCS for KYC verification</p>
          <Link to="/contact" className="btn-cta-large">Request Demo</Link>
        </div>
      </section>
    </div>
  );
};

export default ImprovedHome;
